export const NAMESPACE = 'notifications';
